import { dataCustomer } from "../../../../components/selectCustomer";
import {
    CSRF,
    Management,
    formDataToObject,
    formatCurrency,
    getData,
    getDataFormToObject,
    getElement,
    resetFilter,
} from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";

class BudgetModule extends HTMLElement {
    async connectedCallback() {
        // console.log(this);
        const DtElement = getElement("[data-table=dt]", this);
        const BtnSearch = getElement("[name=search]", this);
        const BtnReset = getElement("[name=reset]", this);
        const Form = getElement("[name=filter]");

        let filter = formDataToObject(Form);
        filter.type = "=";

        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            // Crear cuerpo scrolleable
            scrollY: "370px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("saleBudgetsUrlDt"),
            type: "POST",
            data: function (data) {
                data.filter = filter;
            },
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };
        // Columnas del AJAX
        configDt.columns = [
            // {
            //     data: "check",
            //     width: "2%",
            //     className: "text-center",
            //     orderable: false,
            // },
            { data: "ref", width: "5%", className: "text-center" },
            {
                data: "date_invoice",
                width: "6%",
                className: "text-center",
            },
            { data: "ref_invoice" },
            { data: "customer" },
            { data: "receipt_method" },
            {
                data: "amount",
                className: "text-end",
                render: (data, type, row) => {
                    return formatCurrency(data, "decimal");
                },
            },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            { data: "cif", className: "d-none" },
        ];

        const DtInvoices = new Dt(configDt);
        let T = await DtInvoices.dataTable(DtElement);
        // End DataTable

        BtnSearch?.addEventListener("click", () => {
            filter = getDataFormToObject(Form, filter);

            T.ajax.reload();
        });

        BtnReset?.addEventListener("click", () => {
            filter = formDataToObject(Form);
            filter.type = "=";
            dataCustomer.companies = [];

            resetFilter(Form, filter);

            T.ajax.reload();
        });

        this.addEventListener("click", (e) => {
            const Target = e.target;

            if (Target.name == "check") {
                const IptsCheck = document.querySelectorAll("[name=check]");
                let companySelected = getData(Target, "data-company");

                if (Target.checked) {
                    IptsCheck.forEach((item) => {
                        if (getData(item, "data-company") != companySelected) {
                            item.checked = false;
                            item.disabled = true;
                        }
                    });
                } else {
                    const IptsChecked = Array.from(IptsCheck).filter(
                        (item) => item.checked
                    );

                    if (IptsChecked.length < 1) {
                        IptsCheck.forEach((item) => {
                            item.checked = false;
                            item.disabled = false;
                        });
                    }
                }
            }
        });

        document.body.addEventListener("aj:startYear", (e) => {
            this.disabledByYear();
        });

        this.disabledByYear();
    }

    disabledByYear() {
        const BtnAdd = getElement("#btnAdd", this, false);
        let startYear = parseInt(localStorage.getItem(Management.slug));
        let years = Management.years.map((obj) => obj.year);
        // let minYear = Math.min(...years);
        let maxYear = Math.max(...years);

        if (maxYear - startYear > 1) {
            BtnAdd?.classList.add("d-none");
        } else {
            // if (maxYear - minYear > 1) {
            // if (maxYear - startYear > 0) {
            BtnAdd?.classList.remove("d-none");
            // }
            // }
        }
    }
}

window.customElements.define("budget-module", BudgetModule, {
    extends: "section",
});
